<template>
    <div class="vue-uploadbox-wrap br-8 position-relative" :class="[classes, {'p-10 bg-lighten': mode !== 'aigeneration' }]">
        <div class="d-flex br-8 fg-white h-75 w-100" :class="[background, { 'border-white border-dashed border-1 h-100': mode !== 'aigeneration' }]">
            <RouterView></RouterView>
            <ErrorContainer mode="aigeneration"></ErrorContainer>
        </div>
    </div>
</template>

<script>
import ErrorContainer from './error/ErrorContainer';

export default {
    name: 'UploadBox',
    components: { ErrorContainer },
    props: {
        mode: {
            type: String,
            default: 'default',
        },
        background: {
            type: String,
            default: 'bg-main-5',
        },
    },
    provide() {
        return {
            mode: this.mode,
            background: this.background,
        };
    },
    mounted() {
        this.classes = this.background;

        if (this.mode === 'no_upload') {
            this.classes += ' vue-uploadbox-no-upload';
        }

        let openPage = 'file-upload';

        if (this.mode === 'remote_url') {
            openPage = 'remote-url';
        } else if (this.mode === 'no_upload') {
            openPage = 'no-upload';
        } else if (this.mode === 'aigeneration') {
          openPage = 'aigeneration';
        }

        this.$router.push({ name: openPage });
    },
    data() {
        return {
            classes: '',
        };
    },
};
</script>
